import { render, staticRenderFns } from "./WaybillManagement.vue?vue&type=template&id=4015724e&"
import script from "./WaybillManagement.vue?vue&type=script&lang=js&"
export * from "./WaybillManagement.vue?vue&type=script&lang=js&"
import style0 from "./WaybillManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports